import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const EventsTableInfo = withConfig(theme => styled('div', { label: 'EventsTableInfo' })`
    border-top: 1px solid ${theme.star.eventsTableColors.borderColor};
    padding: 15px 5px 10px 5px;
    position: relative;
    text-align: center;
`);

interface FootballFiltersWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    renderEventFilters: boolean;
}

const setFootballFiltersWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, renderEventFilters: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            @media ${theme.star.mediaQuery.tablet} {
                margin: ${renderEventFilters ? '0 8px' : '8px 8px 0'};
                border-radius: ${renderEventFilters ? '0' : '8px 8px 0 0'};
            }
        `;
    }
    return css`
        border: 1px solid ${theme.star.filtersColors.wrapper.borderColor};
    `;
};

export const FootballFiltersWrapper = withConfig(theme => styled('div', { label: 'FootballFiltersWrapper' })<FootballFiltersWrapperPropsType>`
    ${({ variant, renderEventFilters }): SerializedStyles => setFootballFiltersWrapper(variant, theme, renderEventFilters)}
    background-color: ${theme.star.filtersColors.wrapper.bgColorTertiary};
    padding: 8px 0 8px 8px;
`);

